(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/services/search-receivers.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/services/search-receivers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.ticketsOrderHome.utils.logger;
const {
  NO_SEARCH_RESULTS,
  TOO_MANY_SEARCHES,
  INPUT_VALIDATION_FAILED,
  TOO_MANY_SEARCH_RESULTS,
  UNKNOWN_ERROR
} = svs.ticketsOrderHome.utils.constants.orderHomeReceiver.errors;
const searchReceivers = async data => await svs.tur.apiCaller.ticketgames.getPlayerAdressFinder({
  data
});

const searchReceiversAsync = async _ref => {
  var _receiver$results$len, _receiver$results;
  let {
    firstName,
    lastName,
    street,
    city,
    receiver
  } = _ref;
  try {
    const {
      response: {
        error,
        results
      }
    } = await svs.ticketsOrderHome.services.searchReceivers({
      firstName,
      lastName,
      street,
      city
    });
    if (error) {
      throw error;
    }
    if ((results === null || results === void 0 ? void 0 : results.length) === 0) {
      throw NO_SEARCH_RESULTS;
    }
    const getFirstName = receiver => {
      if (receiver !== null && receiver !== void 0 && receiver.firstName) {
        return receiver.firstName;
      }
      if (receiver !== null && receiver !== void 0 && receiver.names && receiver.names.length > 0) {
        var _receiver$indexPrefer;
        return receiver.names[(_receiver$indexPrefer = receiver.indexPreferredName) !== null && _receiver$indexPrefer !== void 0 ? _receiver$indexPrefer : 0];
      }
      return '';
    };
    return {
      result: results.map(r => _objectSpread(_objectSpread({}, r), {}, {
        firstName: getFirstName(r)
      }))
    };
  } catch (err) {
    switch (err.code) {
      case NO_SEARCH_RESULTS.code:
        logger.info("No search results found, ".concat(street ? 'has' : 'no', " street in query"), err);
        return {
          error: NO_SEARCH_RESULTS
        };
      case TOO_MANY_SEARCH_RESULTS.code:
        logger.info("Too many search results found, ".concat(street ? 'has' : 'no', " street in query"), err);
        return {
          error: TOO_MANY_SEARCH_RESULTS
        };
      case INPUT_VALIDATION_FAILED.code:
        logger.warn('Search parameters failed validation during search', err);
        return {
          error: INPUT_VALIDATION_FAILED
        };
      case TOO_MANY_SEARCHES.code:
        logger.warn("Customer has exceeded maximum amount of searches, with ".concat((_receiver$results$len = (_receiver$results = receiver.results) === null || _receiver$results === void 0 ? void 0 : _receiver$results.length) !== null && _receiver$results$len !== void 0 ? _receiver$results$len : 0, " queries in cache"), err);
        return {
          error: TOO_MANY_SEARCHES
        };
      default:
        logger.warn('Unknown error during search', err);
        return {
          error: UNKNOWN_ERROR
        };
    }
  }
};
setGlobal('svs.ticketsOrderHome.services.searchReceivers', searchReceivers);
setGlobal('svs.ticketsOrderHome.services.searchReceiversAsync', searchReceiversAsync);

 })(window);